// Settings (DESIGN.md "Port-out PIN", mockup i): the company's Port-out card, the account
// number and PIN another carrier must give to move a number away. Admins only.
import { createFileRoute } from "@tanstack/react-router";
import { portOutQuery } from "../../api/ports";
import { requireAdmin } from "../../auth/useMe";
import { PortOutCard } from "../../components/ports/PortOutCard";
import { PageHeader } from "../../components/ui";

export const Route = createFileRoute("/admin/settings")({
  staticData: { crumb: { label: "Settings", parents: [] } },
  beforeLoad: requireAdmin,
  loader: ({ context }) => context.queryClient.prefetchQuery(portOutQuery),
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <>
      <PageHeader title="Settings" />
      <div id="port-out" className="max-w-[960px]">
        <PortOutCard />
      </div>
    </>
  );
}
